<template>
  <div :class="{ 'documents-downloads': true, 'is-loading': !loaded }">
    <fieldset>
      <legend>Documents</legend>

      <d-alert
        v-if="referenceId === 0"
        theme="light"
        show
        class="text-center">
        You will be able to see and add documents after saving this {{ itemName }}.
      </d-alert>

      <d-alert
        v-if="loadError"
        theme="warning"
        show
        class="text-center">
        An error occurred during loading documents.
      </d-alert>

      <d-row
        v-if="loaded && !loadError && referenceId !== 0"
        class="pr-3 mb-3">
        <d-button
          theme="success"
          @click.prevent="addDocument"
          outline
          class="ml-auto">
          Add document
        </d-button>
      </d-row>

      <d-row
        v-if="loaded && !loadError && referenceId !== 0"
        class="pl-3 pr-3">
        <table class="table">
          <thead>
            <tr>
              <th>Name</th>
              <th style="width: 200px;">Actions</th>
            </tr>
          </thead>
          <tbody>
            <document-downloads-list-item
              v-for="(documentData, index) of documents"
              :key="'document-downloads-list-item-' + index"
              :documentData="documentData" />
          </tbody>
        </table>
      </d-row>

      <d-alert
        v-if="loaded && !loadError && referenceId !== 0 && documents.length === 0"
        theme="light"
        show
        class="text-center">
        There are no documents for this {{ itemName }}.
      </d-alert>
    </fieldset>
  </div>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';
import DocumentDownloadsListItem from './DocumentDownloadsListItem.vue';

export default {
  name: 'documents',
  components: {
    'document-downloads-list-item': DocumentDownloadsListItem
  },
  props: {
    referenceId: {
      type: Number,
      required: true
    },
    itemName: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loaded: false,
      loadError: false,
      documents: []
    };
  },
  mounted () {
    if (this.referenceId === 0) {
      this.loaded = true;
    } else {
      this.loadDocuments();
    }

    this.$bus.$on('document-downloads-list-reload', this.reload);
  },
  methods: {
    loadDocuments () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/countries/documents/items/' + parseInt(this.referenceId, 10),
        params: {
          pagination: 0
        },
        loadedKey: 'loaded',
        outputKey: 'documents',
        errorKey: 'loadError'
      });
    },
    addDocument () {
      this.$bus.$emit('show-document-download-popup', 'add', this.referenceId);
    },
    reload () {
      this.loaded = false;
      this.loadDocuments();
    }
  },
  beforeDestroy () {
    this.$bus.$off('document-downloads-list-reload', this.reload);
  }
}
</script>

<style lang="scss" scoped>
.documents-downloads {
  margin: 30px 0;
  position: relative;

  &.is-loading {
    fieldset {
      min-height: 120px;
    }

    &:after {
      background: rgba(255, 255, 255, .66);
      content: "";
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
    }

    &:before {
      content: "Loading data...";
      left: 50%;
      position: absolute;
      top: 50%;
      transform: translateX(-50%) translateY(-50%);
      z-index: 1;
    }
  }
}
</style>
